import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/solid';
import React from 'react';
import { StringTranslations } from '@services';
import ListenPodcastButton from './ListenPodcastButton';
import ShareButton from './ShareButton';
import ViewTranscriptButton from './ViewTranscriptButton';
import { GlobalCmsButtons } from '../../.services/graph.services/get-buttons.services';
import VideoDate from '../VideoDate';

type Props ={
  episode: Boolean
  globalCmsButtons: GlobalCmsButtons,
  handleShowTranscript: Function,
  hasLiveBloggingMsgs: Boolean,
  lang: string,
  liveChatActive: Boolean,
  liveBlogActive: Boolean,
  setLiveBlogActive: Function,
  setLiveChatActive: Function,
  podcastListenUrl: string,
  stringTranslations: StringTranslations,
  transcript: any,
  videoPublishDateAndTime: string,
}

function VideoButtonGroup({
  episode,
  globalCmsButtons,
  handleShowTranscript,
  hasLiveBloggingMsgs,
  lang,
  liveChatActive,
  liveBlogActive,
  setLiveBlogActive,
  setLiveChatActive,
  podcastListenUrl,
  stringTranslations,
  transcript,
  videoPublishDateAndTime,
} : Props) {
  return (
    <div className="flex mt-5 justify-between items-center text-sm mb-3.5">
      <div className="hidden mt-0 text-sm uppercase lg:flex lg:justify-start items-center">
        {videoPublishDateAndTime && <VideoDate date={videoPublishDateAndTime} />}
        <ShareButton
          globalCmsButtons={globalCmsButtons}
          lang={lang}
        />
        {podcastListenUrl && (
          <ListenPodcastButton
            globalCmsButtons={globalCmsButtons}
            lang={lang}
            podcastListenUrl={podcastListenUrl}
          />
        )}
        {transcript && (
        <ViewTranscriptButton
          handleShowTranscript={handleShowTranscript}
          lang={lang}
          styles="mr-8"
          stringTranslations={stringTranslations}
        />
        )}
      </div>
      <div className="flex justify-between w-full lg:w-auto">
        {!episode && hasLiveBloggingMsgs && (
        <button
          type="button"
          onClick={() => setLiveBlogActive(!liveBlogActive)}
          className="flex mr-5 font-semibold text-chdGreen-light hover:text-chdGreen-hover"
        >
          <div
            className="tracking-wider uppercase whitespace-nowrap"
          >
            Live Blog
          </div>
          {liveBlogActive
            ? <ChevronUpIcon className="w-[1.25rem] ml-2" />
            : <ChevronDownIcon className="w-[1.25rem] ml-2" />}
        </button>
        )}
        <button
          type="button"
          onClick={() => setLiveChatActive(!liveChatActive)}
          className="flex font-semibold text-chdGreen-light hover:text-chdGreen-hover"
        >
          <div
            className="tracking-wider uppercase whitespace-nowrap"
          >
            Live Chat
          </div>
          {liveChatActive
            ? (
              <>
                <ChevronLeftIcon className="w-[1.25rem] ml-2 hidden md:block" />
                <ChevronUpIcon className="md:hidden block w-[1.25rem] ml-2" />
              </>
            )
            : (
              <>
                <ChevronRightIcon className="w-[1.25rem] ml-2 hidden md:block" />
                <ChevronDownIcon className="md:hidden block w-[1.25rem] ml-2" />
              </>
            )}
        </button>
        {transcript && (
        <ViewTranscriptButton
          lang={lang}
          stringTranslations={stringTranslations}
          styles="block self-end lg:hidden"
          handleShowTranscript={handleShowTranscript}
        />
        )}
      </div>
    </div>
  );
}

export default VideoButtonGroup;
